
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import axios from "axios";

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import AuthenticationLayout from "../components/AuthenticationLayout";
// Images
import model from "assets/images/telsim.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const SERVER_URL=process.env.REACT_APP_API_URL;  
const API_TOKEN  = process.env.REACT_APP_API_TOKEN 
import{getApiHeader} from "../../../utlis/commonfunctions"

 const headers=getApiHeader()
function Resetpassword() {
  const navigate=useNavigate()
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [newPassword,setNewPassword] = useState("")
  const[password,setPassword]=useState("")
  const [confirmPass,setConfirmPass] = useState("")
  const [error,setError] = useState("")
  const [passError,setPassError] = useState("")
  const [newError,setNewError] = useState("")
    
  
  const handleNewPasswordChange=(event)=>{
    if(event?.target?.value.length < 8 && event?.target?.value.length !=0){
      setNewError("Password should be atleast 8 characters")
    }else{
      setNewError("");
    }
    setNewPassword(event.target.value)
  }

  const handleOldPassword=(event)=>{
    if(event?.target?.value.length < 8 && event?.target?.value.length !=0){
      setError("Password should be atleast 8 characters")
    }else{
      setError("");
    }
    setPassword(event.target.value)
        
  }

  const handleConfirmPasswordChange = (event)=>{
    if(event.target.value != newPassword && event.target.value.length != 0 ){
      setPassError("Passwords must match")
    }else{
      setPassError("")
    }
    setConfirmPass(event.target.value)
  }
  const handleSubmit = async (event) => {
  const token = await sessionStorage.getItem('access_token')
    event.preventDefault(); 
    if (newPassword === '' || password === '' || confirmPass === '') {
      console.error("Input fields cannot be empty");
      return;
    }

    const post_data = { 
      current_password:password,  
      new_password: newPassword,
      new_password_confirmation: confirmPass,
    };
    const header = {
      "api-token" : API_TOKEN,
      "Authorization" : "Bearer " + token
    }

    try {
      const response = await axios.post(`${SERVER_URL}change-password`, post_data, { headers:header});
      if (response.status === 200) {
        // If login is successful, navigate to dashboard
        toast.success(response?.data?.message);
        setTimeout(() => {
        navigate('/dashboard');
        },1000)
      } else {
        toast.error(response?.data?.message);
        console.error("Please enter correct credentials");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("An error occurred:", error);
    }
  };

  return (
    <AuthenticationLayout
      title="Reset your Password"
      description="Please enter your new password below."
      image={""}
    >
    <ToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Enter Your Current Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Current Password"  value={password} onChange={handleOldPassword}/>
          <SoftTypography variant="caption" color="error">{error}</SoftTypography>
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
            Enter Your New Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Password"  value={newPassword} onChange={handleNewPasswordChange}/>
          <SoftTypography variant="caption" color="error">{newError}</SoftTypography>
        </SoftBox>

        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
            Confirm Your Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Confirm Password"  value={confirmPass} onChange={handleConfirmPasswordChange}/>
          <SoftTypography variant="caption" color="error">{passError}</SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="primary" fullWidth   onClick={handleSubmit}>
             Submit
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </AuthenticationLayout>
  );
}

export default Resetpassword;
